import React from 'react'
import { IframeLayout } from '../../components/Layouts';
import { ErrorBoundary } from '@sentry/react';
import { ErrorMsg } from '../../components/AppMessages';
import LoadingEllipsis from '../../components/Loading/LoadingEllipsis';
import { IframePageContent } from '../../components/PageContent';
import { useStreamlitEmbedUrl } from '../../hooks';

interface Props {
  dashboardId: string;
  dashboardUrl: string
}

const AdhocDashboard = (props: Props) => {
  const { dashboardId, dashboardUrl } = props;

  const { iframeUrl, isFetching } = useStreamlitEmbedUrl(`${dashboardId}Token`, dashboardUrl);

  return (
    <IframeLayout hasFilter={false}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {isFetching ?
          <LoadingEllipsis isLoading={isFetching} />
          :
          <IframePageContent
            frameId={`${dashboardId}Dashboard`}
            iframeUrl={iframeUrl} // Use the iframe URL with the token query parameters
          />
        }

      </ErrorBoundary>
    </IframeLayout>
  );
}

export default AdhocDashboard
